var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"myHead"},[_c('el-breadcrumb',{staticStyle:{"margin-top":"20px","margin-left":"20px"},attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/processManager'}}},[_vm._v("重大危险源监控")]),_c('el-breadcrumb-item',[_vm._v("监控列表")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }